import { useCallback } from 'react';
import { useGetStreamData } from '../useGetStreamData';

export const useUpdateLoggerInfo = () => {
	const { getStreamData } = useGetStreamData();

	const updateLoggerInfo = useCallback(
		(prevState, stream) => {
			const logger = { ...prevState.logger };
			if (stream['/record_status']) {
				const logger_status = JSON.parse(
					getStreamData(stream, '/record_status'),
				);
				logger.on = logger_status.flag;
				logger.status = logger_status.record;
				logger.upload = logger_status.upload;
				logger.upload_progress = logger_status.progress;
			}
			return logger;
		},
		[getStreamData],
	);

	return { updateLoggerInfo };
};
